import { categories, assignation, foldersAPI } from 'api'

export const searchFilter = [
  'searchText',
  'limit',
  'outbound',
  'assigned',
  'providers',
  'brands',
  'delegations',
  'states',
  'labels',
  'folders',
  'createdAt',
  'updatedAt',
  'lastMessageDate'
]

const numbersPage = [
  { value: 30, label: '30' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
]

export const fieldsFilters = {
  searchText: {
    type: 'text',
    name: 'searchText',
    className: 'icon-placeholder',
    default: ''
  },
  limit: {
    type: 'select_one',
    name: 'limit',
    label: 'dashboard_show',
    default: 30,
    options: numbersPage.map(numberPage => ({ value: numberPage.value, label: numberPage.label }))
  },
  outbound: {
    type: 'switch',
    name: 'outbound',
    label: 'search_outbound',
    default: false,
    divider: true
  },
  assigned: {
    type: 'select_one_many',
    name: 'assigned',
    label: 'dashboard_operators',
    default: []
  },
  providers: {
    type: 'select_one_many',
    name: 'providers',
    label: 'dashboard_channel',
    default: []
  },
  brands: {
    type: 'brand_delegations',
    name: 'brands',
    label: 'dashboard_brands-and-delegations',
    default: []
  },
  delegations: {
    default: []
  },
  states: {
    type: 'select_one_many',
    name: 'states',
    label: 'dashboard_conversation-state',
    default: []
  },
  labels: {
    type: 'select_one_many',
    name: 'labels',
    label: 'dashboard_labels',
    default: []
  },
  folders: {
    type: 'select_one_many',
    name: 'folders',
    label: 'dashboard_folders',
    default: [],
    divider: true
  },
  createdAt: {
    type: 'date',
    name: 'createdAt',
    label: 'dashboard_createdAt',
    subtitle: 'dashboard_select-date-range',
    default: ['', '']
  },
  updatedAt: {
    type: 'date',
    name: 'updatedAt',
    label: 'dashboard_updatedAt',
    subtitle: 'dashboard_select-date-range',
    default: ['', '']
  },
  lastMessageDate: {
    type: 'date',
    name: 'lastMessageDate',
    label: 'dashboard_last-message',
    subtitle: 'dashboard_select-date-range',
    default: ['', '']
  }
}

export const colsShowInit = [
  'id',
  'name',
  'channel',
  'pendingMsgCount',
  'lastMessageDate'
]

export const colsShow = [
  { value: 'id', key: 'table_header_col_id_conversations', isSelected: false, width: 190 },
  { value: 'name', key: 'table_header_col_name_conversations', isSelected: false, width: 200 },
  { value: 'channel', key: 'table_header_col_channel_conversations', isSelected: false, width: 120 },
  { value: 'pendingMsgCount', key: 'table_header_col_pendingMsgCount_conversations', isSelected: false, width: 100, centered: true },
  { value: 'createdAt', key: 'table_header_col_createdAt_conversations', isSelected: false, width: 130 },
  { value: 'updatedAt', key: 'table_header_col_updatedAt_conversations', isSelected: false, width: 130 },
  { value: 'lastMessageDate', key: 'table_header_col_lastMessageDate_conversations', isSelected: false, width: 130 },
  { value: 'email', key: 'table_header_col_email_conversations', isSelected: false, width: 225 },
  { value: 'phone', key: 'table_header_col_phone_conversations', isSelected: false, width: 130 },
  { value: 'locale', key: 'table_header_col_locale_conversations', isSelected: false, width: 100 },
  { value: 'state', key: 'table_header_col_state_conversations', isSelected: false, width: 100 },
  { value: 'labels', key: 'table_header_col_labels_conversations', isSelected: false, width: 275 },
  { value: 'operators', key: 'table_header_col_operators_conversations', isSelected: false, width: 300 },
  { value: 'brand', key: 'table_header_col_brand_conversations', isSelected: false, width: 200 },
  { value: 'delegation', key: 'table_header_col_delegation_conversations', isSelected: false, width: 200 },
  { value: 'companyName', key: 'conversation_company_name', isSelected: false, width: 200 }
]

export const actionOptions = [
  { label: 'dashboard_mark-as-read', value: 'mark_as_read', withConfirmation: true },
  { label: 'dashboard_mark-as-unread', value: 'mark_as_unread', withConfirmation: true },
  { label: 'dashboard_remove-mnemonics', value: 'remove_mnemonics', withConfirmation: true },
  { label: 'dashboard_assign-operators', value: 'assign_operators', multiple: true, withConfirmation: true },
  { label: 'dashboard_delete-assigned-operators', value: 'delete_assigned_operators', multiple: true, withConfirmation: true },
  { label: 'dashboard_delete-all-assigned-operators', value: 'delete_all_assigned_operators', withConfirmation: true },
  { label: 'dashboard_change-status', value: 'change_status', withConfirmation: true },
  { label: 'dashboard_add-labels', value: 'add_tags', multiple: true, withConfirmation: true },
  { label: 'dashboard_remove-labels', value: 'remove_tags', multiple: true, withConfirmation: true },
  { label: 'dashboard_add-to-folder', value: 'add_to_folder', multiple: true, withConfirmation: true },
  { label: 'dashboard_delete-from-folder', value: 'delete_from_folder', multiple: true, withConfirmation: true },
  { label: 'dashboard_activate-automation', value: 'activate_automation', withConfirmation: true },
  { label: 'dashboard_disable-automation', value: 'disable_automation', withConfirmation: true },
  { label: 'dashboard_change-centers', value: 'change_centers', withConfirmation: true },
  { label: 'dashboard_activate-marketing-subscription', value: 'activate_marketing_subscription', withConfirmation: true },
  { label: 'dashboard_disable-marketing-subscription', value: 'disable_marketing_subscription', withConfirmation: true },
  { label: 'dashboard_add-internal-comment', value: 'add_internal_comment', withMessage: true, withConfirmation: true },
  { label: 'dashboard_delete-conversation', value: 'delete_conversation', withConfirmation: true },
  { label: 'dashboard_export-conversation', value: 'export_conversation', withConfirmation: true },
  { label: 'dashboard_export-csv', value: 'export_csv', withConfirmation: true },
  { label: 'dashboard_export-csv-with-assigned', value: 'export_csv_with_assigned', withConfirmation: true }
]

export const getOperatorsOptions = async () => {
  try {
    let { data: { operators } } = await assignation.getAvailableOperators({
      size: 1000
    })

    return operators.map(({ _id, email }) => ({ value: _id, label: email }))
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getTagsOptions = async () => {
  let tags = []

  try {
    const { data } = await categories.get([], [], 'asc')
    tags = data.map(({ _id, name }) => ({ value: _id, label: name }))
  } catch (error) {
    console.error(error)
    return tags
  }

  return tags
}

export const getFoldersOptions = async () => {
  let folders = []

  try {
    const { data } = await foldersAPI.getFolders({ fields: ['name', 'listId'] })
    folders = data.map(({ listId, name }) => ({ value: listId, label: name }))
  } catch (error) {
    console.error(error)
    return folders
  }

  return folders
}
